import { render, staticRenderFns } from "./TaskCreatedNotification.vue?vue&type=template&id=5b205f98"
import script from "./TaskCreatedNotification.vue?vue&type=script&lang=js"
export * from "./TaskCreatedNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports